import { XHRBackend, RequestOptions } from '@angular/http';
import { HttpService } from './http.interceptor.service';

export function HttpFactory(backend: XHRBackend, options: RequestOptions) {
  return new HttpService(backend, options);
}



// WEBPACK FOOTER //
// ./src/app/shared/services/http.factory.ts